<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
 
    <div class="top_bg"></div>
    <div class="temp">
      <div>
        <div class="temp1">MEIFUZX</div>
        <div class="temp2">公司资讯动态</div>
      </div>
      <div class="temp3"></div>
    </div>
    <div class="temp_container">
      <div class="temp_left">
        <div class="marquee_box" >
          <ul class="marquee_list" :class="{marquee_top:animate}">
              <li v-for="(item,index) in recordList">
                <div style="font-size: 18px;color: #DE2D37;">{{item.content}}</div>
                <div style="margin-top: 22px;font-size: 14px;color: #686868;">{{item.createTime}}</div>
              </li>
          </ul>
        </div>
        <div style="display: flex;align-items: center;margin: 56px 45px;">
          <div style="margin-right: 64px;">
            <div class="temp_img"><img src="../../static/img/contact/professional.png" alt=""></div>
            <div class="temp4">专业性</div>
          </div>
          <div style="margin-right: 67px;">
            <div class="temp_img"><img src="../../static/img/contact/creativity.png" alt=""></div>
            <div class="temp4">创意性</div>
          </div>
          <div style="margin-right: 66px">
            <div class="temp_img"><img src="../../static/img/contact/Leadership.png" alt=""></div>
            <div class="temp4">领导力</div>
          </div>
          <div>
            <div class="temp_img"><img src="../../static/img/contact/Cross.png" alt=""></div>
            <div class="temp4">跨领域</div>
          </div>
        </div>
      </div>
      <div class="temp_right">
          <div v-for="(item,index) in recordLists" :key="index">
              <div v-if="index == 0">
                <div class="img2">
                    <img :src="item.picList[0]" alt="" class="imgone">
                    <div class="imgone_site">{{item.title}}</div>
                  </div>
              </div>
              <div v-if="index == 1">
                <div class="img3">
                    <img :src="item.picList[0]" alt="" class="imgone">
                    <div class="imgone_site">{{item.title}}</div>
                  </div>
              </div>
              <div v-if="index == 2">
                <div class="img4">
                    <img :src="item.picList[0]" alt="" class="imgone">
                    <div class="imgone_site">{{item.title}}</div>
                  </div>
              </div>
              <div v-if="index == 3">
                <div class="img1">
                    <img :src="item.picList[0]" alt="" class="imgone">
                    <div class="imgone_site">{{item.title}}</div>
                  </div>

              </div>
          </div>
      </div>
    </div>
    <div style="width: 1200px;padding-top: 47px;margin: 0 auto;">
      <!-- 新闻资讯 -->
      <div v-for="(item,index) in newsList" :key="index">
        <div class="note_container" @click="jump(item)">
          <div style="display: flex;margin-top: 40px;">
            <div style="width: 440px;height: 294px;">
              <img :src="item.picList[0]" alt="" style="width: 100%;height: 100%;">
            </div>
            <div style="margin-left: 57px;margin-top: 11px;width: 703px;">
              <div>
                <div class="note1">{{item.title}}</div>
              </div>
              <div style="clear: both;"></div>
              <div class="note_time">{{item.createTime}}</div>
              <div class="note_text">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  import * as commonApi from "api/common";
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        newsList: [],
        recordList: [],
        recordLists: [],
        scroll: '',
        scroll100: true,
        scroll700: false,
        animate: false,
        pageIndex:1,
        pageSize:10
      };
    },
    watch: {
      scroll: function () {      
        this.loadSroll();
      }
    },
    methods: {
      showMarquee: function() {
        this.animate = true;
        setTimeout(() => {
          this.recordList.push(this.recordList[0]);
          this.recordList.shift();
          this.animate = false;
        }, 500);
      },
      //跳转新网址的界面
      jump(item){
        window.open(item.link)
      },
      //分页
      handleSizeChange(val) {
        this.pageSize=val
        this.getNews()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.pageIndex=val
        this.getNews()
        console.log(`当前页: ${val}`);
      },
      //首页
      goToHome() {
        this.$router.push("/");
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push("./home");
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push("./supplyChain");
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push("./marketingTools");
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push("./company");
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push("./channels");
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push("./contact");
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push("./culture");
      },
     //找美商学院-商学院文化
     goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
        this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      //新闻资讯
      getNews() {
        const params = {
          status: 1,
          type: 1,
          search_text: '',
          // page:this.pageIndex,
          // count:this.pageSize
        };
        commonApi
          .getNewsList(params)
          .then(res => {
            let { data } = res;
            if (data.code == 200 && data.data.result == 1) {
              this.newsList = res.data.data.data
              
            }
          })
          .catch(() => {

          });
      },
      //招聘信息
      getRecruit() {
        const params = {
          status: 1,
          type: 2,
          search_text: ''
        };
        commonApi
          .getNewsList(params)
          .then(res => {
            let { data } = res;
            if (data.code == 200 && data.data.result == 1) {
              this.recordList = res.data.data.data
              this.recordLists = res.data.data.data
            }
          })
          .catch(() => {

          });
      },
      //滚动条
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() {
      setInterval(this.showMarquee, 2000);
    },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])
    },
    mounted() {
      this.getNews()
      this.getRecruit()
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
  }

  .top_bg {
    background-image: url("../../static/img/contact/link_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 824px;
    position: relative;
    top: 0;
    left: 0;
  }

  .temp {
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 61px;
    width: 1200px;
  }

  .temp1 {
    font-size: 36px;
    font-weight: 800;
    line-height: 54px;
    letter-spacing: 3px;
    color: #343434;
  }

  .temp2 {
    font-size: 26px;
    color: #343434;
    line-height: 37px;
    letter-spacing: 2px;
    margin-top: 11px;
  }

  .temp3 {
    width: 694px;
    height: 2px;
    background: rgba(216, 225, 224, 1);
  }

  .temp_container {
    width: 1200px;
    padding-top: 42px;
    display: flex;
    /* align-items: center; */
    margin: 0 auto;
  }

  .temp_left {
    width: 606px;
    height: 507px;
    background: rgba(255, 255, 255, 1);
    /* border: 1px solid rgba(222, 45, 55, 1); */
    border: 1px solid #999;
  }

  .temp5 {
    font-size: 18px;
    color: #DE2D37;
    font-weight: 500;
  }

  .temp6 {
    width: 508px;
    /* height: 78px; */
    font-size: 14px;
    line-height: 26px;
    margin-top: 22px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    /*要显示的行数*/
    -webkit-box-orient: vertical;
  }

  

  .temp_img {
    width: 46px;
    height: 44px;
  }

  .temp_img img {
    width: 100%;
    height: 100%;
  }

  .temp4 {
    font-size: 14px;
    color: #DE3038;
  }

  .temp_right {
    width: 600px;
    height: 509px;
    background: rgba(0, 0, 0, 1);
    position: relative;
    margin-left: -1px;
  }

  .img1 {
    width: 288px;
    height: 299px;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
  }

  .imgone {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .imgone:hover {
    transform: scale(1.05);
    transition: all 0.5s linear;
  }

  .imgone_site {
    width: 229px;
    height: 29px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.5131;
    position: absolute;
    bottom: 10px;
    left: 30px;
    color: #fff;
    text-align: center;
    padding-top: 3px;
  }

  .img2 {
    width: 289px;
    height: 196px;
    position: absolute;
    top: 0;
    right: 0;
    overflow: hidden;
  }

  .img3 {
    width: 289px;
    height: 196px;
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: hidden;
  }

  .img4 {
    width: 288px;
    height: 299px;
    position: absolute;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }

  .note_container {
    border-top: 1px dashed #DBDBDB;
    margin-bottom: 42px;
    cursor: pointer;
  }

  .note1 {
    font-size: 22px;
    color: #050505;
    float: left;
    max-width: 620px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .note_container:hover .note1{
    color: red;
  }

  .note2 {
    font-size: 14px;
    color: #0D0D0D;
    float: right;
  }

  .note_time {
    font-size: 16px;
    color: #6F6F6F;
    margin-top: 16px;
  }

  .note_text {
    font-size: 16px;
    line-height: 36px;
    letter-spacing: 1px;
    margin-top: 25px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 5;
    /*要显示的行数*/
    -webkit-box-orient: vertical;
  }

 



.marquee_box {
  display: block;
  position: relative;
  width: 508px;
  height: 300px;
  margin-left: 45px;
  margin-top: 40px;
  overflow: hidden;
}

.marquee_list {
  display: block;
}

.marquee_top {
  transition: all 0.5s;
  margin-top: -125px;
}

.marquee_list li {
  height: 125px;
  font-size: 14px;
  /* padding-left: 20px; */
}
</style>


// WEBPACK FOOTER //
// src/page/contact.vue